import React, { useEffect } from "react";
import dayjs from "dayjs";
import { Form, Image } from "antd";
import Button from "@/common/elements/Button";
import {
  StyledFlex,
  StyledGridCol,
  StyledGridRow,
  StyledInformationList,
  StyledSectionHeading
} from "@/common/styles";
import { InmateInformation } from "@/components/InmateHeader/styles";
import { getFinalPath, getRefListNameByID, isNonEmptyVariable } from "@/util/common_function";
import { PHOTOS_BASE_URL } from "@/util/api";
import defaultAvatar from "@/assets/default_avatar.svg";
import { useSelector } from "react-redux";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import TextField from "@/common/elements/InputElements/TextField";

const JailIncidentInvolvedInmateInformation = ({ bookings, showTopBar = true, showBasicInfo = false, from = "bookings", onSave, selectedInmate,disabled=false }) => {
  const refList = useSelector((state) => state?.refListReducer?.refLists);
  const bio = bookings?.bio?.[0] || {};
  const inmateName = bio.lName && bio.fName
    ? `${bio.lName}, ${bio.fName} ${bio.mName || ""}`
    : "-";
  const inmateNumber = from == "bookings" ? (bookings?.bioId || "") : selectedInmate?.inmateNumber || "-";

  const arrestDate = from == "bookings" ? (bookings?.arrestReports?.[0]?.arrestDate
    ? dayjs(bookings.arrestReports[0].arrestDate).format("MM/DD/YYYY")
    : "-") : (selectedInmate?.arrestDate ? dayjs(selectedInmate?.arrestDate).format("MM/DD/YYYY") : "-");
  const scheduledReleaseDate = from == "bookings" ? (bookings?.arrestReports?.[0]?.scheduledReleaseDate
    ? dayjs(bookings.arrestReports[0].scheduledReleaseDate).format("MM/DD/YYYY")
    : "-") : selectedInmate?.scheduledReleaseDate
    ? dayjs(selectedInmate?.scheduledReleaseDate).format("MM/DD/YYYY")
    : "-";
  const dob = from == "bookings" ? (bio.dob ? dayjs(bio.dob).format("MM/DD/YYYY") : "-") : (selectedInmate?.dob ? dayjs(selectedInmate?.dob).format("MM/DD/YYYY") : "-");

  const classification = from == "bookings" ? bookings?.arrestReports?.[0]?.classificationId : selectedInmate?.classification;
  const classificationName = getRefListNameByID("Classifications", classification, false) || "-";
  const assignedLocation = from == "bookings" ? (bookings?.arrestReports?.[0]?.currentLocation || "-") : (selectedInmate?.assignedLocation || "-");
  const currentLocation = from == "bookings" ? (bookings?.arrestReports?.[0]?.currentLocation || "-") : (selectedInmate?.currentLocation || "-");
  const pinNo = from == "bookings" ? (bio.pinNo || "-") : (selectedInmate?.pinNo || "-");
  const bookingNumber = from == "bookings" ? (bookings?.bookingNumber || "-") : (selectedInmate?.bookingNumber);
  const facilityStatus = from == "bookings" ? (bookings?.arrestReports?.[0]?.workhouseStatusId || "-") : (selectedInmate?.facilityStatus || "-");

  const bioPhotoPath = from=="bookings"?(bio.bioPhotos?.[0]?.photos?.[0]?.fullSizePath):(selectedInmate?.bioPhotos?.[0]?.photos?.[0]?.fullSizePath);
  const bioPhotoUrl = bioPhotoPath
    ? PHOTOS_BASE_URL + getFinalPath(bioPhotoPath)
    : defaultAvatar;

  const [form] = Form.useForm()
  useEffect(() => {
    if (from == "facilityLog") {
      if (isNonEmptyVariable(selectedInmate)) {
        let { fname, lname, suffix } = selectedInmate
        let setObj = {
          lName: lname,
          fName: fname,
          suffix
        }
        form.setFieldsValue(setObj)
      }
      else {
        form.resetFields()
      }
    }
  }, [selectedInmate])
  function HandleSearch() {
    form.validateFields().then((data) => onSave(data)).catch(console.log)
  }
  return (
    <>
      <StyledSectionHeading marginTop="0px">
        <span>Inmate Information</span>
      </StyledSectionHeading>

      {showTopBar && (
        <StyledGridRow>
          <StyledGridCol flex="auto" marginBottom="10px">
            <InmateInformation>
              <div className="value red">
                <h5 style={{ margin: "0px" }}>
                  {inmateName} {inmateNumber && `(${inmateNumber})`}
                </h5>
              </div>
            </InmateInformation>
          </StyledGridCol>

          <StyledGridCol>
            <StyledFlex align="center" style={{ minHeight: "38px" }}>
              <Button
                type="secondary"
                color="secondary"
                icon={<span style={{ fontSize: "22px", marginBottom: "10px" }}>...</span>}
              />
            </StyledFlex>
          </StyledGridCol>
        </StyledGridRow>
      )}

      {showBasicInfo && (
        <>
          <Form form={form} disabled={disabled}>
            <StyledGridRow gutter={16}>

              <StyledGridCol>
                <FormItem label="Last Name" name="lName">
                  <TextField />
                </FormItem>
              </StyledGridCol>

              <StyledGridCol>
                <FormItem label="First Name" name="fName">
                  <TextField />
                </FormItem>
              </StyledGridCol>

              <StyledGridCol>
                <FormItem label="Middle Name" name="mName">
                  <TextField />
                </FormItem>
              </StyledGridCol>

              <StyledGridCol>
                <FormItem label="Suffix" name="suffix">
                  <TextField />
                </FormItem>
              </StyledGridCol>
              {from == "facilityLog" && !!!disabled &&<StyledGridCol span={5} lg={3} marginTop="30px">
                <FormItem>
                  <Button onClick={HandleSearch}>search</Button>
                </FormItem>
              </StyledGridCol>}
            </StyledGridRow>
          </Form>
        </>
      )}

      <StyledInformationList style={{ padding: "0px" }}>
        <div className="result--box result--full-width" style={{ paddingTop: "8px" }}>
          <StyledGridRow gutter={16}>
            <StyledGridCol lg={6}>
              <div style={{ textAlign: "center" }}>
                <Image
                  src={bioPhotoUrl}
                  alt="Inmate Photo"
                  width={200}
                  height={200}
                  fallback={defaultAvatar}
                />
              </div>
            </StyledGridCol>
            <StyledGridCol lg={18}>
              <StyledGridRow gutter={16}>
                <StyledGridCol span={8}>
                  <div className="key">Arrest Date</div>
                  <p className="value">{arrestDate}</p>
                </StyledGridCol>
                <StyledGridCol span={8}>
                  <div className="key">Sched. Rel. Date</div>
                  <p className="value">{scheduledReleaseDate}</p>
                </StyledGridCol>
                <StyledGridCol span={8}>
                  <div className="key">Classification</div>
                  <p className="value">{classificationName}</p>
                </StyledGridCol>
                <StyledGridCol span={8}>
                  <div className="key">Assigned Location</div>
                  <p className="value">{assignedLocation}</p>
                </StyledGridCol>
                <StyledGridCol span={8}>
                  <div className="key">Current Location</div>
                  <p className="value">{currentLocation}</p>
                </StyledGridCol>
                <StyledGridCol span={8}>
                  <div className="key">Pin No</div>
                  <p className="value">{pinNo}</p>
                </StyledGridCol>
                <StyledGridCol span={8}>
                  <div className="key">Booking Number</div>
                  <p className="value">{bookingNumber}</p>
                </StyledGridCol>
                <StyledGridCol span={8}>
                  <div className="key">Facility Status</div>
                  <p className="value">{facilityStatus}</p>
                </StyledGridCol>
                <StyledGridCol span={8}>
                  <div className="key">DOB</div>
                  <p className="value">{dob}</p>
                </StyledGridCol>
              </StyledGridRow>
            </StyledGridCol>
          </StyledGridRow>
        </div>
      </StyledInformationList>
    </>
  );
};

export default JailIncidentInvolvedInmateInformation;
